module.exports = __webpack_public_path__ + "static/media/bookizon-logo.aca922a0.svg";